var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "CSChatThai", staticStyle: { background: "#2562af" } },
    [
      _vm.stateShow == "showMenu"
        ? _c("div", [
            _c(
              "div",
              { staticStyle: { background: "#2562af" } },
              [
                _c(
                  "v-layout",
                  { attrs: { row: "", wrap: "" } },
                  [
                    _c(
                      "v-flex",
                      {
                        attrs: {
                          xs11: "",
                          xl11: "",
                          lg11: "",
                          md11: "",
                          sm11: ""
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { "padding-left": "10px" } },
                          [
                            _c("v-text-field", {
                              staticClass: "bgsearchweb CSChatThai",
                              staticStyle: { color: "white !important" },
                              attrs: {
                                color: "white",
                                "hide-details": "",
                                "append-icon": "search",
                                label: "ค้นหาเพื่อนหรือกลุ่ม",
                                solo: "",
                                clearable: ""
                              },
                              model: {
                                value: _vm.search,
                                callback: function($$v) {
                                  _vm.search = $$v
                                },
                                expression: "search"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "center",
                          "vertical-align": "middle",
                          position: "relative"
                        },
                        attrs: { xs1: "", xl1: "", lg1: "", md1: "", sm1: "" }
                      },
                      [
                        _c(
                          "div",
                          {},
                          [
                            _c(
                              "v-menu",
                              {
                                attrs: { "offset-y": "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                staticStyle: {
                                                  background: "#0000001c",
                                                  margin: "0 -15px",
                                                  position: "absolute",
                                                  top: "50%",
                                                  "-ms-transform":
                                                    "translateY(-50%)",
                                                  transform: "translateY(-50%)"
                                                },
                                                attrs: { icon: "", small: "" }
                                              },
                                              on
                                            ),
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "white" } },
                                                [_vm._v("mdi-dots-vertical")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3094066259
                                )
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  "v-list",
                                  { staticStyle: { padding: "0" } },
                                  [
                                    _c(
                                      "v-list-tile",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.gotopath("/my_profile")
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "v-list-tile-title",
                                          {
                                            staticStyle: {
                                              "font-size": "12px !important"
                                            }
                                          },
                                          [_vm._v("โปรไฟล์")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-tile",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.gotopath("/add_friend")
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "v-list-tile-title",
                                          {
                                            staticStyle: {
                                              "font-size": "12px !important"
                                            }
                                          },
                                          [_vm._v("เพิ่มเพื่อน")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "v-layout",
                      {
                        staticStyle: { padding: "10px !important" },
                        attrs: { row: "", wrap: "" }
                      },
                      [
                        _c(
                          "v-flex",
                          {
                            attrs: {
                              xs3: "",
                              xl3: "",
                              lg3: "",
                              md3: "",
                              sm3: ""
                            },
                            on: {
                              click: function($event) {
                                return _vm.selectedTabMenu("friend")
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                class:
                                  _vm.TabMenu == "friend"
                                    ? "Menu_headerStyle_Selected"
                                    : "Menu_headerStyle"
                              },
                              [_c("span", [_vm._v("เพื่อน")])]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          {
                            attrs: {
                              xs3: "",
                              xl3: "",
                              lg3: "",
                              md3: "",
                              sm3: ""
                            },
                            on: {
                              click: function($event) {
                                return _vm.selectedTabMenu("group")
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                class:
                                  _vm.TabMenu == "group"
                                    ? "Menu_headerStyle_Selected"
                                    : "Menu_headerStyle"
                              },
                              [_c("span", [_vm._v("กลุ่ม")])]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          {
                            attrs: {
                              xs3: "",
                              xl3: "",
                              lg3: "",
                              md3: "",
                              sm3: ""
                            },
                            on: {
                              click: function($event) {
                                return _vm.selectedTabMenu("chat")
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                class:
                                  _vm.TabMenu == "chat"
                                    ? "Menu_headerStyle_Selected"
                                    : "Menu_headerStyle"
                              },
                              [_c("span", [_vm._v("แชท")])]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "padding-right": "10px",
                  "padding-left": "10px",
                  "border-top-left-radius": "20px !important",
                  "border-top-right-radius": "20px !important",
                  background: "white",
                  "padding-bottom": "10px",
                  height: "90%"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "border-top-left-radius": "10px !important",
                      "border-top-right-radius": "10px !important",
                      background: "white",
                      "padding-bottom": "10px",
                      height: "calc(100vh - 145px) !important",
                      "overflow-y": "scroll"
                    }
                  },
                  [
                    _vm.TabMenu == "friend" ||
                    (_vm.TabMenu == "chat" && _vm.FilterChatList.length == 0)
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              padding: "12px 0px 0px 0px",
                              "justify-content": "center",
                              display: "flex"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "createGroupStyle",
                                on: {
                                  click: function($event) {
                                    return _vm.gotopath("/add_friend")
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: {
                                          xs2: "",
                                          xl2: "",
                                          lg2: "",
                                          md2: "",
                                          sm2: ""
                                        }
                                      },
                                      [
                                        _c(
                                          "v-avatar",
                                          {
                                            attrs: {
                                              color: "white",
                                              size: "40px"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticStyle: {
                                                  "font-size": "24px"
                                                },
                                                attrs: { color: "#909090" }
                                              },
                                              [_vm._v("person_add")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: {
                                          xs10: "",
                                          xl10: "",
                                          lg10: "",
                                          md10: "",
                                          sm10: ""
                                        }
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              color: "#4e4e4ec2",
                                              "margin-bottom": "0 !important",
                                              "margin-left": "10px",
                                              "font-weight": "800 !important"
                                            }
                                          },
                                          [_vm._v("เพิ่มเพื่อน")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "#909090c9",
                                              "margin-bottom": "0 !important",
                                              "margin-left": "10px",
                                              "font-size": "12px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "ค้นหาเพื่อนที่คุณรู้จักเพื่อพูดคุย"
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm.TabMenu == "group"
                      ? _c(
                          "div",
                          { staticStyle: { padding: "12px 0px 0px 0px" } },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "createGroupStyle",
                                on: {
                                  click: function($event) {
                                    return _vm.gotopath("/create_group")
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: {
                                          xs2: "",
                                          xl2: "",
                                          lg2: "",
                                          md2: "",
                                          sm2: ""
                                        }
                                      },
                                      [
                                        _c(
                                          "v-avatar",
                                          {
                                            attrs: {
                                              color: "white",
                                              size: "40px"
                                            }
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                staticStyle: {
                                                  "font-size": "24px"
                                                },
                                                attrs: { color: "#909090" }
                                              },
                                              [_vm._v("group_add")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: {
                                          xs10: "",
                                          xl10: "",
                                          lg10: "",
                                          md10: "",
                                          sm10: ""
                                        }
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              color: "#4e4e4ec2",
                                              "margin-bottom": "0 !important",
                                              "margin-left": "10px",
                                              "font-weight": "800 !important"
                                            }
                                          },
                                          [_vm._v("สร้างกลุ่ม")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "#909090c9",
                                              "margin-bottom": "0 !important",
                                              "margin-left": "10px",
                                              "font-size": "12px"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "สร้างกลุ่มสำหรับคุณและเพื่อน"
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.FilterGroupPendingList.length > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "createGroupStyle",
                                    staticStyle: { "margin-top": "2px" },
                                    on: {
                                      click: function($event) {
                                        _vm.stateShow = "showPendingGroup"
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-layout",
                                      { attrs: { row: "", wrap: "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: {
                                              xs2: "",
                                              xl2: "",
                                              lg2: "",
                                              md2: "",
                                              sm2: ""
                                            }
                                          },
                                          [
                                            _c(
                                              "v-avatar",
                                              {
                                                attrs: {
                                                  color: "white",
                                                  size: "40px"
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "24px"
                                                    },
                                                    attrs: { color: "#909090" }
                                                  },
                                                  [_vm._v("mdi-account-group")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-flex",
                                          {
                                            staticStyle: { margin: "auto" },
                                            attrs: {
                                              xs10: "",
                                              xl10: "",
                                              lg10: "",
                                              md10: "",
                                              sm10: ""
                                            }
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticStyle: {
                                                  color: "#4e4e4ec2",
                                                  "margin-bottom":
                                                    "0 !important",
                                                  "margin-left": "10px",
                                                  "font-weight":
                                                    "800 !important"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "คำเชิญเข้ากลุ่ม (" +
                                                    _vm._s(
                                                      _vm.FilterGroupPendingList
                                                        .length
                                                    ) +
                                                    ")  "
                                                ),
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticStyle: {
                                                      color:
                                                        "#4e4e4ec2 !important",
                                                      "font-size":
                                                        "20px !important",
                                                      float: "right"
                                                    }
                                                  },
                                                  [_vm._v("chevron_right")]
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.TabMenu == "friend" && _vm.FilterFriendList.length != 0
                      ? _c(
                          "v-list",
                          { attrs: { "two-line": "" } },
                          [
                            _vm._l(_vm.FilterFriendList, function(item, index) {
                              return [
                                _c(
                                  "v-list-tile",
                                  {
                                    attrs: { avatar: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.selectRoom(item)
                                      }
                                    }
                                  },
                                  [
                                    _vm.checkOnline_user(item.friend_user_id)
                                      ? _c(
                                          "v-list-tile-avatar",
                                          [
                                            _c(
                                              "v-avatar",
                                              {
                                                class: item.friend_profile_picture
                                                  ? "defaultPicOnlinehavePic"
                                                  : "defaultPicOnline",
                                                attrs: { size: "40" }
                                              },
                                              [
                                                _c(
                                                  "v-badge",
                                                  {
                                                    attrs: {
                                                      rigth: "",
                                                      bottom: "",
                                                      color: "#1ace21"
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "badge",
                                                          fn: function() {
                                                            return [_c("span")]
                                                          },
                                                          proxy: true
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  },
                                                  [
                                                    _vm._v(" "),
                                                    item.friend_profile_picture
                                                      ? _c("img", {
                                                          staticClass:
                                                            "alligator-turtle",
                                                          staticStyle: {
                                                            width: "40px",
                                                            display:
                                                              "table-cell",
                                                            height: "40px"
                                                          },
                                                          attrs: {
                                                            src:
                                                              _vm.backend +
                                                              item.friend_profile_picture
                                                          }
                                                        })
                                                      : _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "white--text headline",
                                                            staticStyle: {
                                                              height: "40px",
                                                              width:
                                                                "40px !important",
                                                              display:
                                                                "table-cell"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item
                                                                  .friend_display_name
                                                                  .length >= 2
                                                                  ? item.friend_display_name.charAt(
                                                                      0
                                                                    ) +
                                                                      item.friend_display_name.charAt(
                                                                        1
                                                                      )
                                                                  : item.friend_display_name.charAt(
                                                                      0
                                                                    )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _c(
                                          "v-list-tile-avatar",
                                          {
                                            attrs: {
                                              color: "#2562af",
                                              size: "40"
                                            }
                                          },
                                          [
                                            item.friend_profile_picture
                                              ? _c("img", {
                                                  staticClass:
                                                    "alligator-turtle",
                                                  attrs: {
                                                    src:
                                                      _vm.backend +
                                                      item.friend_profile_picture
                                                  }
                                                })
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "white--text headline"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.friend_display_name
                                                          .length >= 2
                                                          ? item.friend_display_name.charAt(
                                                              0
                                                            ) +
                                                              item.friend_display_name.charAt(
                                                                1
                                                              )
                                                          : item.friend_display_name.charAt(
                                                              0
                                                            )
                                                      )
                                                    )
                                                  ]
                                                )
                                          ]
                                        ),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-tile-content",
                                      [
                                        _c("v-list-tile-title", {
                                          staticClass: "CSChatThai NameBorder",
                                          domProps: {
                                            textContent: _vm._s(
                                              item.friend_display_name
                                            )
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("v-list-tile-sub-title", {
                                          staticClass: "CSChatThai",
                                          domProps: {
                                            textContent: _vm._s(
                                              item.friend_status
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                index != _vm.FilterFriendList.length - 1
                                  ? _c("v-divider")
                                  : _vm._e()
                              ]
                            })
                          ],
                          2
                        )
                      : _vm.TabMenu == "group" &&
                        _vm.FilterGroupList.length != 0
                      ? _c(
                          "v-list",
                          { attrs: { "two-line": "" } },
                          [
                            _vm._l(_vm.FilterGroupList, function(item, index) {
                              return [
                                _c(
                                  "v-list-tile",
                                  {
                                    attrs: { avatar: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.selectRoom(item)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-list-tile-avatar",
                                      {
                                        attrs: { color: "#2562af", size: "40" }
                                      },
                                      [
                                        item.room_picture
                                          ? _c("img", {
                                              staticClass: "alligator-turtle",
                                              attrs: {
                                                src:
                                                  _vm.backend +
                                                  item.room_picture
                                              }
                                            })
                                          : _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "white--text headline"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.room_name.length >= 2
                                                      ? item.room_name.charAt(
                                                          0
                                                        ) +
                                                          item.room_name.charAt(
                                                            1
                                                          )
                                                      : item.room_name.charAt(0)
                                                  )
                                                )
                                              ]
                                            )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-tile-content",
                                      [
                                        _c("v-list-tile-title", {
                                          staticClass: "CSChatThai NameBorder",
                                          domProps: {
                                            textContent: _vm._s(item.room_name)
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                index != _vm.FilterGroupList.length - 1
                                  ? _c("v-divider")
                                  : _vm._e()
                              ]
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.TabMenu == "chat" && _vm.FilterChatList.length != 0
                      ? _c(
                          "v-list",
                          { attrs: { "two-line": "" } },
                          [
                            _vm._l(_vm.FilterChatList, function(item, index) {
                              return [
                                item.room_type == "user"
                                  ? _c(
                                      "v-list-tile",
                                      {
                                        attrs: { avatar: "" },
                                        on: {
                                          click: function($event) {
                                            return _vm.selectRoom(item)
                                          }
                                        }
                                      },
                                      [
                                        _vm.checkOnline_user(
                                          item.friend_user_id
                                        )
                                          ? _c(
                                              "v-list-tile-avatar",
                                              [
                                                _c(
                                                  "v-avatar",
                                                  {
                                                    class: item.friend_profile_picture
                                                      ? "defaultPicOnlinehavePic"
                                                      : "defaultPicOnline",
                                                    attrs: { size: "40" }
                                                  },
                                                  [
                                                    _c(
                                                      "v-badge",
                                                      {
                                                        attrs: {
                                                          rigth: "",
                                                          bottom: "",
                                                          color: "#1ace21"
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "badge",
                                                              fn: function() {
                                                                return [
                                                                  _c("span")
                                                                ]
                                                              },
                                                              proxy: true
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      },
                                                      [
                                                        _vm._v(" "),
                                                        item.friend_profile_picture
                                                          ? _c("img", {
                                                              staticClass:
                                                                "alligator-turtle",
                                                              staticStyle: {
                                                                width: "40px",
                                                                display:
                                                                  "table-cell",
                                                                height: "40px"
                                                              },
                                                              attrs: {
                                                                src:
                                                                  _vm.backend +
                                                                  item.friend_profile_picture
                                                              }
                                                            })
                                                          : _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "white--text headline",
                                                                staticStyle: {
                                                                  height:
                                                                    "40px",
                                                                  width:
                                                                    "40px !important",
                                                                  display:
                                                                    "table-cell"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item
                                                                      .friend_display_name
                                                                      .length >=
                                                                      2
                                                                      ? item.friend_display_name.charAt(
                                                                          0
                                                                        ) +
                                                                          item.friend_display_name.charAt(
                                                                            1
                                                                          )
                                                                      : item.friend_display_name.charAt(
                                                                          0
                                                                        )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          : _c(
                                              "v-list-tile-avatar",
                                              {
                                                attrs: {
                                                  color: "#2562af",
                                                  size: "40"
                                                }
                                              },
                                              [
                                                item.friend_profile_picture
                                                  ? _c("img", {
                                                      staticClass:
                                                        "alligator-turtle",
                                                      attrs: {
                                                        src:
                                                          _vm.backend +
                                                          item.friend_profile_picture
                                                      }
                                                    })
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "white--text headline"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item
                                                              .friend_display_name
                                                              .length >= 2
                                                              ? item.friend_display_name.charAt(
                                                                  0
                                                                ) +
                                                                  item.friend_display_name.charAt(
                                                                    1
                                                                  )
                                                              : item.friend_display_name.charAt(
                                                                  0
                                                                )
                                                          )
                                                        )
                                                      ]
                                                    )
                                              ]
                                            ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-tile-content",
                                          { attrs: { "two-line": "" } },
                                          [
                                            _c("v-list-tile-title", {
                                              staticClass:
                                                "CSChatThai NameBorder",
                                              domProps: {
                                                textContent: _vm._s(
                                                  item.friend_display_name
                                                )
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "v-list-tile-sub-title",
                                              { staticClass: "CSChatThai" },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.setLastMessage(item)
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-tile-action",
                                          [
                                            _c("v-list-tile-action-text", [
                                              item.last_message_time
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "CSChatThai timeListChat"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.time(
                                                            item.last_message_time
                                                          )
                                                        ) + " "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]),
                                            _vm._v(" "),
                                            item.count_not_read
                                              ? _c(
                                                  "v-chip",
                                                  {
                                                    staticClass: "ma-2",
                                                    attrs: {
                                                      color: "red",
                                                      "text-color": "white"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          item.count_not_read
                                                        ) +
                                                        "\n                "
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : item.room_type == "group"
                                  ? _c(
                                      "v-list-tile",
                                      {
                                        attrs: { avatar: "" },
                                        on: {
                                          click: function($event) {
                                            return _vm.selectRoom(item)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "v-list-tile-avatar",
                                          {
                                            attrs: {
                                              color: "#2562af",
                                              size: "40"
                                            }
                                          },
                                          [
                                            item.room_picture
                                              ? _c("img", {
                                                  staticClass:
                                                    "alligator-turtle",
                                                  attrs: {
                                                    src:
                                                      _vm.backend +
                                                      item.room_picture
                                                  }
                                                })
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "white--text headline"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.room_name.length >=
                                                          2
                                                          ? item.room_name.charAt(
                                                              0
                                                            ) +
                                                              item.room_name.charAt(
                                                                1
                                                              )
                                                          : item.room_name.charAt(
                                                              0
                                                            )
                                                      )
                                                    )
                                                  ]
                                                )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-tile-content",
                                          [
                                            _c("v-list-tile-title", {
                                              staticClass:
                                                "CSChatThai NameBorder",
                                              domProps: {
                                                textContent: _vm._s(
                                                  item.room_name
                                                )
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "v-list-tile-sub-title",
                                              { staticClass: "CSChatThai" },
                                              [
                                                item.member_status === "active"
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.setLastMessage(
                                                            item
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  : item.member_status ===
                                                    "pending"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color:
                                                            "#bdbdbda8 !important"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "โปรดกดยืนยันเข้ากลุ่ม"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        item.member_status === "active"
                                          ? _c(
                                              "v-list-tile-action",
                                              [
                                                item.last_message_time
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "CSChatThai timeListChat"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.time(
                                                              item.last_message_time
                                                            )
                                                          ) + " "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.count_not_read
                                                  ? _c(
                                                      "v-chip",
                                                      {
                                                        staticClass: "ma-2",
                                                        attrs: {
                                                          color: "red",
                                                          "text-color": "white"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              item.count_not_read
                                                            ) +
                                                            "\n                "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          : item.member_status === "pending"
                                          ? _c(
                                              "v-list-tile-action",
                                              [
                                                _c(
                                                  "v-chip",
                                                  {
                                                    staticClass: "ma-2",
                                                    attrs: {
                                                      color: "green",
                                                      "text-color": "white"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n            N\n          "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                index != _vm.FilterChatList.length - 1
                                  ? _c("v-divider")
                                  : _vm._e()
                              ]
                            })
                          ],
                          2
                        )
                      : _vm.TabMenu == "chat" && _vm.listRoom.length == 0
                      ? _c("div", [
                          _vm.state == "show data"
                            ? _c(
                                "span",
                                {
                                  staticStyle: {
                                    "margin-top": "10px",
                                    "text-align": "center"
                                  }
                                },
                                [_vm._v("คุณยังไม่มีห้องแชท")]
                              )
                            : _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex !important",
                                    "justify-content": "center !important",
                                    width: "100%",
                                    height: "65vh",
                                    padding: "20px"
                                  }
                                },
                                [
                                  _c("v-progress-circular", {
                                    attrs: {
                                      indeterminate: "",
                                      color: "primary",
                                      size: 80,
                                      width: 5
                                    }
                                  })
                                ],
                                1
                              )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          ])
        : _vm.stateShow == "showPendingGroup"
        ? _c("div", [
            _c(
              "div",
              { staticClass: "CSChatThai" },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      background: "#2562af !important",
                      "padding-bottom": "10px"
                    }
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        staticStyle: { margin: "0 !important" },
                        attrs: { icon: "" },
                        on: {
                          click: function($event) {
                            _vm.stateShow = "showMenu"
                          }
                        }
                      },
                      [
                        _c("v-icon", { staticClass: "white--text" }, [
                          _vm._v("chevron_left")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "white--text",
                        staticStyle: {
                          "font-weight": "600",
                          "white-space": "nowrap",
                          width: "80%",
                          overflow: "hidden",
                          "text-overflow": "ellipsis",
                          display: "inline-block",
                          "vertical-align": "middle",
                          "text-align": "center"
                        }
                      },
                      [
                        _vm._v(
                          "คำเชิญเข้ากลุ่ม (" +
                            _vm._s(_vm.FilterGroupPendingList.length) +
                            ") "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.FilterGroupPendingList.length != 0
                  ? _c(
                      "v-list",
                      { attrs: { "two-line": "" } },
                      [
                        _vm._l(_vm.FilterGroupPendingList, function(
                          item,
                          index
                        ) {
                          return [
                            _c(
                              "v-list-tile",
                              {
                                attrs: { avatar: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.selectRoom(item)
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-list-tile-avatar",
                                  { attrs: { color: "#2562af", size: "40" } },
                                  [
                                    item.room_picture
                                      ? _c("img", {
                                          staticClass: "alligator-turtle",
                                          attrs: {
                                            src: _vm.backend + item.room_picture
                                          }
                                        })
                                      : _c(
                                          "span",
                                          {
                                            staticClass: "white--text headline"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.room_name.length >= 2
                                                  ? item.room_name.charAt(0) +
                                                      item.room_name.charAt(1)
                                                  : item.room_name.charAt(0)
                                              )
                                            )
                                          ]
                                        )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-list-tile-content",
                                  [
                                    _c("v-list-tile-title", {
                                      staticClass: "CSChatThai NameBorder",
                                      domProps: {
                                        textContent: _vm._s(item.room_name)
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            index != _vm.FilterGroupList.length - 1
                              ? _c("v-divider")
                              : _vm._e()
                          ]
                        })
                      ],
                      2
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9666909e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9666909e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mail/ListRoom.vue
// module id = null
// module chunks = 